export const SUPPORTED_COVER_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
